export const TableHelpers = {
    data() {
      return {
        tableColumns: [
          {
            title: "Expediente",
            type: "custom-html",
            key: "record",
            modifier: (value, row) => {
              return value;
            },
          },
          // {
          //   title: this.$t("Tipo acreditación"),
          //   type: "custom-html",
          //   key: "accreditation_type",
          //   modifier: (value) => {
          //     return value?.name;
          //   },
          // },
          {
            title: 'Actividad',
            type: 'custom-html',
            key: 'accreditation_activity',
            modifier: (value) => {
                return value?.name;
            }
          },
          {
            title: "Nombre comercial",
            type: "custom-html",
            key: "organization",
            modifier: (value) => {
              return value?.name;
            },
          },
          {
            title: "Razón social",
            type: "custom-html",
            key: "organization",
            modifier: (value) => {
              return value?.business_name;
            },
          },
        ],
        actionObj: {
          title: this.$t("action"),
          type: "action",
        },
      };
    },
  };
  